/**
 * 最近使用的分组管理（Web 应用版本）
 * 用于记忆用户最后操作的分组，下次新增待办事项时默认选择该分组
 */

const LAST_USED_GROUP_KEY = 'last_used_group_id';

/**
 * 获取最近使用的分组ID
 */
export async function getLastUsedGroupId(): Promise<string | null> {
  try {
    const groupId = localStorage.getItem(LAST_USED_GROUP_KEY);
    return groupId || null;
  } catch (error) {
    console.warn('[LastUsedGroup] 获取最近使用的分组失败:', error);
    return null;
  }
}

/**
 * 保存最近使用的分组ID
 */
export async function setLastUsedGroupId(groupId: string): Promise<void> {
  try {
    localStorage.setItem(LAST_USED_GROUP_KEY, groupId);
  } catch (error) {
    console.warn('[LastUsedGroup] 保存最近使用的分组失败:', error);
  }
}

/**
 * 清除最近使用的分组ID
 */
export async function clearLastUsedGroupId(): Promise<void> {
  try {
    localStorage.removeItem(LAST_USED_GROUP_KEY);
  } catch (error) {
    console.warn('[LastUsedGroup] 清除最近使用的分组失败:', error);
  }
}
